import * as db from '../../db'
import _ from 'lodash'
import { router } from '../../router/index'
var uniqid = require("uniqid");

export const LOADING_TRANSACTION = 'LOADING_TRANSACTION'
export const LOAD_TRANSACTION = 'LOAD_TRANSACTION'
export const CREATING_TRANSACTION = 'CREATING_TRANSACTION'
export const GET_TRANSACTION = 'GET_TRANSACTION'

// initial state
const state = {
  loading: false,
  creating: false,
  transaction: {},
  transactions: {},
  loadedTransaction: '',
  transactionUserInfo:null,
  // ************ DO NOT CHANGE THE ORDER OF THE STATUS ARRAY.
  // ************ ADD TO THE END OF THE ARRAY
  status: ['pending', 'processed', 'error', '']
}

// getters
const getters = {
  transaction: state => state.transaction,
  transactions: state => _.values(state.transactions),
  loadedTransaction: state => state.loadedTransaction,
  loading: state => state.loading,
  creating: state => state.creating,
  transactionUserInfo:state => state.transactionUserInfo,
  statusOptions: state => _.values(state.status)
}

// actions
const actions = {
  transactionUserInfo({commit}, payload){ 
    let transactionsUser = null
    db.users.doc(payload.id).get().then((doc) => {
      transactionsUser = doc.data()
  }).then(() => {
      commit('setuserInfo', transactionsUser)
  })
  },
  getTransaction({ commit, dispatch }, params) {
    commit(GET_TRANSACTION, null);
    db.transactions
      .doc(params.transactionId)
      .get()
      .then(transaction => {
        if (transaction.exists) {
          console.log("TCL: getTransaction -> transaction", transaction.data());
          if (
            params.userId === transaction.data().user.id &&
            params.transactionId === transaction.id

          ) {
            commit(GET_TRANSACTION, transaction.data());
            dispatch('transactionUserInfo', {
              id: params.userId
            })
          } else {
            router.push({ path: "/" });
          }
        } else {
          router.push({ path: "/" });
        }
      })
      .catch(error => {
        console.log("error:", error);
        router.push({ path: "/" });
      });
  },

  createTransaction({ commit }, data) {
    // const amount = data.amount
    const companies = data.companies;
    const design = data.design;
    const floorplan = data.floorplan;
    const project = data.project;
    const totals = data.totals;
    const user = data.user;
    const unit = data.unit;

    let newTransaction = {
      orderId: uniqid(),
      companies: companies,
      dateCreated: new Date(),
      design: design,
      floorplan: floorplan,
      installStatus: state.status[3],
      lastUpdate: new Date(),
      paymentStatus: state.status[0],
      project: project,
      totals: totals,
      transaction: {},
      user: user,
      unit: unit
    };
    commit(CREATING_TRANSACTION, true);
    db.transactions
      .add(newTransaction)
      .then(docRef => {
        console.log("transaction created", docRef.id);

        commit(LOAD_TRANSACTION, docRef.id);
        commit(CREATING_TRANSACTION, false);
      })
      .catch(err => {
        console.log("something went wrong", err);
        commit(CREATING_TRANSACTION, false);
        return;
      });
  },
  // updateTransaction({ commit }, data) {
  //   const transaction = data.transaction
  //   const transactionId = data.transactionId
  //   const paymentStatus = data.paymentStatus
  //   const installStatus = data.installStatus
  //   const errors = data.errors || ''

  //   commit(LOADING_TRANSACTION, true)

  //   db.transactions
  //     .doc(transactionId)
  //     .update({
  //       transaction: transaction,
  //       lastUpdate: new Date(),
  //       paymentStatus: paymentStatus,
  //       installStatus: installStatus,
  //       errors: errors
  //     })
  //     .then(docRef => {
  //       console.log('update complete')

  //       // conditional to check type of update
  //       if (installStatus === state.status[0]) {
  //         // status is pending, so send email to each installer
  //         let companyBundles = []
  //         for (let company in bundleCompanies) {
  //           if (typeof bundleCompanies[company].companyName !== 'undefined') {
  //             // find the bundles that pertain to the company
  //             companyBundles = cartBundles.filter(
  //               bundle =>
  //                 bundleCompanies[company].companyName.toLowerCase() ===
  //                 bundle.company.toLowerCase()
  //             )
  //             // send email using the bundles to the correct company
  //             actions.sendEmail({
  //               from: 'Signalflow <info@iotypro.com>',
  //               to: bundleCompanies[company].companyEmail,
  //               subject: 'New Customer Installation Request',
  //               text: email.installer(companyBundles).textMessage,
  //               html: email.installer(companyBundles).htmlMessage
  //             })
  //           }
  //         }
  //       }
  //       commit(LOADING_TRANSACTION, false)
  //     })
  //     .catch(err => {
  //       console.log(err)
  //       commit(LOADING_TRANSACTION, false)
  //       return
  //     })
  // },

  sendEmail({ commit }, data) {
    let apiEndpoint =
      "https://us-central1-ioty-admin.cloudfunctions.net/sendEmail";
    console.log("Sending emails...\nData: ", JSON.stringify(data));
    fetch(apiEndpoint, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " +
            response.status
          )
          return;
        }
        // email was successful
        console.log('success', response);
        // response.json().then(data => {
        //   console.log('success',data);
        // })
      })
      .catch(err => {
        // error occurred
        console.log("Error with Fetch.", err)
      });
  }
};

// mutations
const mutations = {
  [LOADING_TRANSACTION](state, value) {
    state.loading = value
  },
  [CREATING_TRANSACTION](state, { value, callback }) {
    state.creating = value
  },
  [LOAD_TRANSACTION](state, value) {
    state.loadedTransaction = value
  },
  [GET_TRANSACTION](state, value) {
    state.transaction = value
  },
  setuserInfo(state,payload){
    state.transactionUserInfo = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/payments.js